/**
 * Created by yangrui on 2021/4/23.
 */
'use strict';
const urlList={
    '134':'/ceshi',
    '205':'',
};

const urlList2={
    '134':'"/ceshi"',
    '205':'""',
};

const dev=process.env.VUE_APP_ENV;
const env=process.env.NODE_ENV;
console.log('--环境控制 111',dev,env);

exports.config = {
    baseENV:dev||'',
    baseURL:urlList[dev]||''
}

exports.config2={
    baseENV:dev||'',
    baseURL:urlList2[dev]||'""'
}
